<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center" (click)="clicked()">
        <h5 class="medium float-left"> {{'customerOnBoarding'|translate }} </h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" name="cobBack" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back'|translate}}
        </button>
    </div>
</div>
<div class="w-100 float-left mb-4 b-b">
    <div class="row container" (click)="clicked()">
        <div class="col-lg-8 col-md-8">
            <div class="form-group align-v-center">
                <label class="medium nowrap mr-3" for="excelTypeSelect">{{'chooseTemplate'|translate}} :</label>
                <select class="form-control" id="excelTypeSelect" name="cobExcelTypeSelect"
                        (change)="onFileTypeChange($event.target.value)">
                    <option>.{{'xlsx' | translate}}</option>
                    <option>.{{'xls' | translate}}</option>
                </select>
                <a href="javascript:void(0)" class="btn ml-3" (click)="downloadTemplate()">{{'download'|translate}}
                    {{'template'|translate}}</a>
            </div>
        </div>
    </div>
    <div class="form-group align-v-center" (click)="clicked()">
        <label class="medium col-2" for="excelTypeSelect">{{'selectFileUpload'|translate}}:</label>
        <div class="relative">
            <input class="fileInput" type="file" name="cobFileBrowse" (change)="chooseFile($event)"
                   accept=".xlsx,.xls,.XLSX,.XLS"/>
            <button class="btn btn-primary ml-3" name="cobFileBrowseBtn">{{'browse'|translate}}</button>
        </div>
        <label class="mb-0 ml-2" *ngIf="fileNameToUpload != null"> {{fileNameToUpload}}</label>

    </div>
    <ng-container *ngIf="fileNameToUpload != null">
        <div class="form-group w-100 float-left align-v-center" (click)="clicked()">
            <label class="medium col-2" for="comments">{{'comments'|translate}} :</label>
            <textarea placeholder="{{'enterComments' | translate}}" name="cobComments" id="comments" rows="2"
                      class="form-control w-25 ml-3"
                      [(ngModel)]="comments"></textarea>
        </div>
        <div class="form-group w-100 float-left align-v-center" (click)="clicked()">
            <label class="medium col-2"></label>
            <button class="btn btn-primary ml-3" name="cobUpload" (click)="processCob()"
                    [disabled]="uploadButtonDisable">{{'upload'|translate}}
            </button>
        </div>
    </ng-container>
</div>
<div class="w-100 float-left mb-4">
    <div class="w-100 float-left align-v-center mb-3" (click)="clicked()">
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-primary float-right" name="cobRefreshGrid" (click)="getAll()"
                [disabled]="uploadButtonDisable">
            <i class="fa fa-refresh mr-2 text-white"></i> {{'refreshGrid'|translate}}
        </button>
    </div>
    <div class="col-lg-12 col-md-12 float-left">
        <div class="light-bg w-100 p-2 grid-details" (click)="clicked()">
            <div class="col-2">
                <h6 class="mb-0 medium">{{'comments'|translate}}</h6>
            </div>
            <div class="col-2">
                <h6 class="mb-0 medium">{{'startDate'|translate}}</h6>
            </div>
            <div class="col-2">
                <h6 class="mb-0 medium">{{'status'|translate}}</h6>
            </div>
            <div class="col-2">
                <h6 class="mb-0 medium">{{'failureReason'|translate}}</h6>
            </div>
            <div class="col-3">
                <h6 class="mb-0 medium">{{'attachFiles'|translate}} </h6>
            </div>
            <div class="col-1">
                <h6 class="mb-0 medium">{{'action'|translate}} </h6>
            </div>
        </div>
        <ng-container>
            <div class="w-100 p-2 grid-details" *ngFor="let data of allData; let i=index">
                <div class="col-2">
                    <h6 class="mb-0">{{data.comment}} </h6>
                </div>
                <div class="col-2">
                    <h6 class="mb-0">{{getDateFormat(data.startDate)}}</h6>
                </div>
                <div class="col-2">
                    <h6 class="mb-0">{{data.state | translate}}</h6>
                </div>
                <div class="col-2">
                    <h6 class="mb-0">{{data.failureReason}}</h6>
                </div>
                <div class="col-3">
                    <a href="#/menu/cob" class="mb-0 small" *ngIf="data.attachedFiles.length > 0"
                       ngbTooltip="{{'clickToDownload' | translate}}"
                       (click)="downloadValidationFile(data.attachedFiles[0].filePath)">{{data.attachedFiles[0].fileType
                        | translate}}.{{getExtension(data.attachedFiles[0].name)}}
                    </a>
                    <br/>
                    <a href="#/menu/cob" class="mb-0 small" *ngIf="data.attachedFiles.length > 1"
                       ngbTooltip="{{'clickToDownload' | translate}}"
                       (click)="downloadValidationFile(data.attachedFiles[1].filePath)">{{data.attachedFiles[1].fileType
                        | translate}}.{{getExtension(data.attachedFiles[1].name)}}
                    </a>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative">
                    <h6 class="mb-lg-0" (click)="conTanActions(i)" ngbTooltip="{{'clickForMoreOption' | translate}}">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="i == trackHides">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ng-container *ngIf="data.state == 'VALIDATED'">
                            <ul class="m-0 p-0">
                                <li (click)="uploadConfirm(data.id)">
                                    <i class="fa fa-upload  mr-2"></i> {{'confirmUpload' | translate}}
                                </li>
                                <li (click)="cancelProcess(data.id)">
                                    <i class="fa fa fa-times mr-2"></i> {{'cancelProcess' | translate}}
                                </li>

                            </ul>
                        </ng-container>
                        <ng-container *ngIf="data.state != 'VALIDATED'">
                            <ul class="m-0 p-0">
                                <li> {{"noActions" | translate}}</li>
                            </ul>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- PAGINATION -->

    <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
        <h6 class="float-left mb-0"> {{((page-1)*pageSize)+1}} - {{pageSize*(page-1)+allPageData.numberOfElements}}
            {{'itemsOf' | translate}} {{allPageData.totalElements}}
        </h6>
        <div class="float-left ml-2 align-v-center">
            <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
            <select class="form-control float-left w-auto ml-2 mb-0" name="cobItemsPerPage" [(ngModel)]="pageSize"
                    (change)="OnPageSizeChanged($event.target.value)">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div style="flex-grow: 1;"></div>
        <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [pageSize]="pageSize" [maxSize]="5"
                        [ellipses]="false" [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                        class="float-right"></ngb-pagination>
        <div (click)="onRefresh()" data-toggle="tooltip" data-placement="bottom" title="Refresh"
             style="margin-right:1px; margin-left:10px;cursor: pointer;"><i class="fa fa-refresh"
                                                                            aria-hidden="true"></i></div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/cob/cob.component.html